import React from "react";

const SimplePlusIcon = ({ color = "var(--color-primary)" }) => (
	<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12.6621 7.67578H7.41211V12.9258H5.91211V7.67578H0.662109V6.17578H5.91211V0.925781H7.41211V6.17578H12.6621V7.67578Z" fill={color} />
	</svg>
);

export default SimplePlusIcon;
